import { SessionCreatedEvent, SessionServiceReadyEvent } from '@studyportals/student-interfaces';
import store from '..';
import { Dependency, Inject, ResolveDependencies } from '@/utils/dependency-decorator';
import globals from '@/utils/globals';

export class LoginStatusCheckerPlugin {
	private static readonly instance: LoginStatusCheckerPlugin = new LoginStatusCheckerPlugin();

	@ResolveDependencies
	public async initialize(
		@Inject(Dependency.SESSION_SERVICE) sessionServiceEvent?: SessionServiceReadyEvent
	): Promise<void> {
		const isLoggedIn = await sessionServiceEvent?.sessionService.getSession();

		store.mutations.setLoggedInState(isLoggedIn !== null);
		globals.eventAggregationService.subscribeTo(SessionCreatedEvent.EventType, LoginStatusCheckerPlugin.instance);
	}

	public notify(event: SessionCreatedEvent): void {
		if (event.eventType === SessionCreatedEvent.EventType) {
			void store.mutations.setLoggedInState(true);
		}
	}
}
